import React, { forwardRef } from 'react';

import { Box, type BoxProps } from '@atlaskit/primitives/compiled';

export type TBodyProps = BoxProps<'tbody'>;

/**
 * __TBody__
 * @primitive
 */
export const TBody: React.ForwardRefExoticComponent<Omit<TBodyProps, "ref"> & React.RefAttributes<HTMLTableSectionElement>> = forwardRef<HTMLTableSectionElement, TBodyProps>(
	({ children, ...props }, ref) => (
		<Box as="tbody" {...props} ref={ref}>
			{children}
		</Box>
	),
);
